import {BehaviorSubject, combineLatest} from 'rxjs';
import {filter, map, shareReplay, startWith, throttleTime} from 'rxjs/operators';
import {mc} from '@px/helper/mc';
import {sd} from '@px/da';
import {userInfo$} from '@px/streams/user';
import {wwData$} from '@px/streams/worker-data';
import Msg = ww.Msg;
import ContractAccountsData = ww.ContractAccountsData;

export const accounts$ = new BehaviorSubject<ContractAccount[]>([]);

wwData$
  .pipe(
    filter<Msg<ContractAccountsData>>((o) => o.type === 'accounts'),
    map<Msg<ContractAccountsData>, ContractAccount[]>((o) => o.data.accounts)
  )
  .subscribe((accounts) => accounts$.next(accounts));

wwData$.pipe(filter((o) => o.type === 'et-track')).subscribe((o) => {
  if (o.data.params && o.data.params.phase === 'ws_error' && o.data.params.content) {
    try {
      const content = JSON.parse(o.data.params.content);
      if (content?.code === 6019) {
        mc.send('toast', 'error', {message: 'Too many requests, Please try again later'});
      }
    } catch {}
  }
  sd.track(o.data.event, o.data.params);
});
